import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";

export const Route = createFileRoute("/p/$slug")({
  // Paid-media landing pages — never index. A generic SSR title keeps the
  // document compliant (axe `document-title`); SEOHead/Helmet swap in the
  // slug-specific title after hydration.
  head: () => ({
    meta: [
      { title: "Tax Resolution — Free Case Review | Comprehensive Tax Resolution" },
      { name: "robots", content: "noindex, nofollow, noarchive, nosnippet, noimageindex" },
      { name: "googlebot", content: "noindex, nofollow" },
    ],
  }),
  component: () => <LandingPage />,
});
